//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import links from "../links";
import texts from "./texts";

export default {
  name: "research",
  mixins: [links, texts],
  methods: {
    goToDatadista() {
      window.open(this.datadistaLink);
    },
    goToTelegram() {
      window.open(this.gitHubTelegramLink);
    },
    goToGitHubCorona() {
      window.open(this.gitHubCoronaLink);
    },
    goToGitHubWeb() {
      window.open(this.gitHubWebLink);
    },
    goToGitHubBicis() {
      window.open(this.gitHubBicisLink);
    },
    goToGitHubSW() {
      window.open(this.gitHubSWLink);
    },
  },
};
